import { WidgetFeature } from 'enums/WidgetFeature';
import { useSelector } from 'react-redux';

export const useIsHistoryApiEnabled = (): boolean => {
    const { features, parameters } = useSelector((state) => ({
        features: state.features,
        parameters: state.parameters,
    }));
    const defaultValue = features[WidgetFeature.UseHistoryAPI];
    const overrideValue = parameters?.overrideFeatures?.[WidgetFeature.UseHistoryAPI];

    return Boolean(typeof overrideValue === 'undefined' ? defaultValue : overrideValue);
};
